import styled from 'styled-components';

export const Bracketstyles = styled.div`
  .bracket-wrap {
    position: relative;
    width: 100%;
    height: 2300px;
    margin-top: 30px;
    touch-action: pan-y;
    user-select: none;
  }

  .connector {
    position: absolute;
    transition:
      transform 520ms cubic-bezier(0.22, 1, 0.36, 1),
      height 520ms cubic-bezier(0.22, 1, 0.36, 1);
    will-change: transform, height;
  }

  .connector svg {
    position: absolute;
    left: 0;
    overflow: visible;
  }

  .capTop {
    top: 0;
  }

  .capBottom {
    bottom: 0;
  }

  .stemWrap {
    position: absolute;
    left: 0;
    overflow: hidden;
    transition:
      height 520ms cubic-bezier(0.22, 1, 0.36, 1),
      top 520ms cubic-bezier(0.22, 1, 0.36, 1);
    will-change: height;
  }

  .stemSvg {
    position: static !important;
    display: block;
    width: 100%;
    height: 100%;
  }

  .nib {
    transition: top 520ms cubic-bezier(0.22, 1, 0.36, 1);
    will-change: top;
  }
`;
